import { AnyAction } from "redux";

const isUnauthenticatedErrorAction = (
  action: AnyAction
): action is { type: string; error: Error } => {
  return action.error?.message === "Unauthorized";
};

export default isUnauthenticatedErrorAction;
